import { useQuery } from 'react-query';
import axios from 'axios';
import { SECOND } from 'time-constants';

import { apiConfig } from '@constants';
import { helpers } from '@helpers';
import { ContinueWatchingResponse } from '@types';

const getVODContinueWatching = async (retry = false): Promise<ContinueWatchingResponse> => {
  try {
    const headers = await helpers.getDspAuthHeader(retry);
    const { data } = await axios.get(`${apiConfig.DSP_CONTINUE_WATCHING}?ct_min=0.01`, { headers });

    return data;
  } catch (error) {
    if (retry) {
      throw error;
    }
    return await getVODContinueWatching(true);
  }
};

export const useGetContinueWatching = () =>
  useQuery('getVODContinueWatching', () => getVODContinueWatching(), {
    refetchOnWindowFocus: true,
    refetchInterval: 30 * SECOND,
    retryDelay: 5 * SECOND,
  });
